import { PessoaDTO } from "@/types/pessoa";

/**
 * Estado da sessão de autenticação. É a única fonte da verdade do usuário
 * logado em memória; o localStorage é apenas uma projeção persistida deste
 * estado (ver AuthProvider). O tempo de vida da sessão é governado pelo token
 * no back-end (o interceptor do httpClient desloga no 401) — por isso não há
 * controle de expiração no client.
 */
export interface SessionState {
  /** Usuário autenticado, ou `null` quando a sessão está encerrada. */
  user: PessoaDTO | null;
}

export type SessionAction =
  /** Login bem-sucedido. */
  | { type: "login"; user: PessoaDTO }
  /** Sessão encerrada. */
  | { type: "logout" }
  /** Atualiza campos do usuário logado (ex.: foto) localmente. */
  | { type: "patchUser"; patch: Partial<PessoaDTO> }
  /** Substitui o usuário por uma versão fresca do servidor (rehidratação). */
  | { type: "replaceUser"; user: PessoaDTO }
  /** Sincroniza com o storage após mudança em outra aba. */
  | { type: "sync"; user: PessoaDTO | null };

/** Reducer puro: sem efeitos colaterais, fácil de testar. */
export function sessionReducer(state: SessionState, action: SessionAction): SessionState {
  switch (action.type) {
    case "login":
      return { user: action.user };

    case "logout":
      return { user: null };

    case "patchUser":
      if (!state.user) return state;
      return { user: { ...state.user, ...action.patch } };

    case "replaceUser":
      // Só rehidrata se ainda houver sessão ativa: evita "ressuscitar" um
      // usuário cujo logout aconteceu enquanto o GET /me estava em voo.
      if (!state.user) return state;
      return { user: action.user };

    case "sync":
      return { user: action.user };

    default:
      return state;
  }
}
